export const NEW_SPEED_PROFILE = {
  Name: 'Новый профиль'
};
